export const en = {
    '0-17': 'Younger than 18',
    '18-24': '18-24',
    '25-34': '25-34',
    '35-44': '35-44',
    '45-54': '45-54',
    '55-': 'Over 55',
    age: 'Age',
    'all-ages': 'Any',
    'all-genders': 'All',
    female: 'Female',
    male: 'Male'
};
